export const BLOG_CATEGORY_LOADING = "BLOG_CATEGORY_LOADING";
export const BLOG_CATEGORIES = "BLOG_CATEGORIES";
export const BLOG_ARTICLES = "BLOG_ARTICLES";
export const BLOG_ARTICLE = "BLOG_ARTICLE";
export const BLOG_LOADING = "BLOG_LOADING";
export const BLOG_CATEGORY = "BLOG_CATEGORY";
export const BLOG_TOTAL_PAGES = "BLOG_TOTAL_PAGES";
